jQuery(document).ready(function($) {
	
	/* ----------------------------

	Smooth Scroll with jQuery:

	Perform a smooth page scroll to an anchor on the same page. It has some logic built in to identify those jump links, and not target other links.
	
	https://css-tricks.com/snippets/jquery/smooth-scrolling/

	---------------------------- */
	
	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[data-toggle="collapse"]')
		.not('.tabs-link')
		.click(function(event) {
			var hash = this.hash;
			
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
				&& 
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 400, function() {
						// Callback after animation
						if (window.location.href.indexOf('#') !== -1) {
							window.location.href = window.location.href.split('#')[0] + hash;	
						} else {
							window.location.href = window.location.href + hash;
						}
					});
				}
			}
		});
});